<app-sale-contract-grid
[permissionKey]="'saleContracts.list'"
[filter]="['ThirdId.Id eq ' + element.Id]"
(add)="onAddButtonClicked()"
[columns]="SaleContractColumns"
></app-sale-contract-grid>